const plumnoteData = {
  name: "Plumnote - Notebook",
  tagline: "The notebook that remembers where you wrote it.",
  description:
    "Formerly \"Advanced To-Do List | Notepad\". Write a note on any web page and it waits for you there the next time you visit. Notes, to-dos and a web clipper — private, offline, and free forever, with optional sync through your own Google Drive.",
  storeUrl:
    "https://chromewebstore.google.com/detail/mibfplaelemmjmeljhlfnhdmmajgdeio",
  features: [
    "Write anywhere — a floating panel on any website (Plumnote icon → Show panel). Drag it, resize it, fold it into a small bubble.",
    "Notes that come back — pin a note to a page or a whole site; a small bubble shows how many are waiting on your next visit.",
    "Clip what matters — select text, right-click, and save the quote with the page title, a clean link and the date.",
    "To-do lists, properly — checklists, headings, lists, quotes, code, highlights and links. Type \"/\" for blocks or use Markdown shortcuts.",
    "Today — one click opens today's page, with yesterday's unfinished to-dos carried over.",
    "Organised — Inbox, notebooks, pinned notes, colour labels, fast search, templates for meetings, reading notes and weekly plans, Trash with 30-day undo.",
    "Optional sync through your own Google Drive — off by default; turn it on to use the same notes on several computers. No account of ours, no server of ours: notes go straight from your browser to a hidden folder in your own Drive and back.",
    "Private by design — no Plumnote account, no tracking, no ads. The in-page panel runs in its own secure frame, so websites cannot read what you type.",
  ],
  btnBack: "Back",
  btnInstall: "Get Plumnote on the Chrome Web Store",
};

export default plumnoteData;
